import { useCallback, useState } from 'react';

export function useRoadClassFilterTooltip() {
  const [roadFilterOpen, setRoadFilterOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleRoadClassFilterClickCallback = useCallback(
    (e: { currentTarget: HTMLElement }) => {
      setAnchorEl(e.currentTarget);
      setRoadFilterOpen(true);
    },
    [],
  );

  return {
    roadFilterOpen,
    setRoadFilterOpen,
    anchorEl,
    handleRoadClassFilterClickCallback,
  };
}
